    export const formatLabel = (name) => {
    return name
      .replace(/_/g, ' ')          
      .replace(/\b\w/g, (c) => c.toUpperCase()); 
  };